<!-- eslint-disable no-debugger -->
<!-- eslint-disable no-debugger -->
<template>
  <div data-spy="scroll" data-target=".site-navbar-target" data-offset="300">
    <div class="site-wrap">
      <router-view />
    </div>
  </div>
</template>

<script>
//import HelloWorld from './components/HelloWorld.vue'
//import DigitalBook from "./pages/DigitalBook.vue";
export default {
  name: "App",
  components: {
    //DigitalBook,
    //HelloWorld
  },
  data() {
    return {
      isScrolled: false,
      activeItem: "home",
      pageIndex: 2,
      backgroundImage: "Images/openbook.jpg",
      navItems: [
        { id: "home", text: "Home", href: "#home" },
        { id: "aboutus", text: "About Us", href: "#aboutus" },
        { id: "howitworks", text: "How It Works", href: "#howitworks" },
        // { id: "contactus", text: "Contact Us", href: "#contactus" },
      ],
      homeSlides: [
        {
          id: 1,
          img: "/Images/IllustrationExample.png",
          text: "",
        },
        {
          id: 2,
          img: "/Images/BookPage1.png",
          text: "Our storybook toolkit let’s your child fire their imagination to create a story bought to life by the power of their own voice.",
        },
        {
          id: 3,
          img: "/Images/BookPage2.png",
          text: "Spoken language is the foundation of all learning. Help your child develop and improve theirs with the power of storytelling. ",
        },
        {
          id: 4,
          img: "/Images/BookPage3.png",
          text: "My Books By Me is the simplest, most inclusive way for children to create stories to share with loved ones.",
        },
        {
          id: 5,
          img: null,
          text: "Are you ready to tell us a story?",
        },
      ],
    };
  },
  computed: {
    selectedSlide() {
      return this.homeSlides[this.pageIndex];
    },
  },
  methods: {
    setActive(id) {
      this.activeItem = id; // Set the clicked item as active
    },
    handleScroll() {
      // eslint-disable-next-line no-debugger

      // Add or remove the 'scrolled' class based on scroll position
      this.isScrolled = window.scrollY > 50;
    },
  },
  mounted() {
    // eslint-disable-next-line no-debugger

    // Attach the scroll event listener
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    // Clean up the scroll event listener
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style>
#app {
  font-family: "Comic Sans MS", "Comic Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
</style>
